import type { EChartsOption } from "echarts";
import EChartBase from "./EChartBase";
import { toneColor } from "./ChartTheme";

export type BarDatum = {
  label: string;
  value: number;
  tone?: string;
  color?: string;
  [key: string]: any;
};

type Props = {
  data: BarDatum[];
  height?: number | string;
  horizontal?: boolean;
  onItemClick?: (item: BarDatum) => void;
};

export default function BarChart({ data, height = 320, horizontal = false, onItemClick }: Props) {
  const labels = data.map((x) => x.label);
  const values = data.map((x) => ({
    value: x.value,
    itemStyle: { color: x.color || toneColor(x.tone) },
    raw: x,
  }));

  const option: EChartsOption = {
    tooltip: { trigger: "axis" },
    grid: { left: horizontal ? 110 : 45, right: 20, top: 20, bottom: 45 },
    xAxis: horizontal ? { type: "value" } : { type: "category", data: labels, axisLabel: { rotate: 20 } },
    yAxis: horizontal ? { type: "category", data: labels } : { type: "value" },
    series: [
      {
        type: "bar",
        data: values,
        barMaxWidth: 34,
      },
    ],
  };

  return (
    <EChartBase
      option={option}
      height={height}
      empty={!data?.length}
      onItemClick={(p) => onItemClick?.(p.data?.raw)}
    />
  );
}